webpackJsonp([61671625695467],{

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactTwitterWidgets = __webpack_require__(55);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container main-section' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Paul Kimbrel - Web Developer and Systems Architect, Sound Engineer.' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-8 level-one' },
	                _react2.default.createElement(
	                    'article',
	                    null,
	                    _react2.default.createElement(
	                        'header',
	                        null,
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'My Photos'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Instagram is fantastic. Here we have a tool that really connects people through photography in a way that no other site has. Sure, they weren\'t the first photo-sharing platform. However, the other are all about "how to store the photo". Instagram is about how to SHARE the photo. Unless you\'re a professional photographer that needs to control access to your photos, have multiple photo sizes, show the photo shoot details to the Nth degree, then chances are you don\'t need anything more than what Instagram provides.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'However, there\'s one problem. Instagram pushes a common theme found amongst other social media products - a "here and now" mentality. Photos have a few nanoseconds to capture your attention. And over time, the relevance of a photo diminishes as it falls farther down the timeline.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'And dang it - I\'ve taken some darn good photos out there. I want the world to see them. So rather than reposting them on Instagram again (which I may still do), here are some of my Instagram photos that I\'m particularly proud to show.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'article',
	                    null,
	                    _react2.default.createElement(
	                        'header',
	                        null,
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'withDate' },
	                            'Fall Photos'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'time',
	                                { dateTime: '2014-10-21' },
	                                'Oct 21, 2014'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The first image here was one of my first Instagram photos - taken on Oct 28, 2010. Fall is a time when Instagram really shines. The filters have always brought out the best of Fall - its colors. The first photo here was taken on my first iPhone, too - the iPhone 3s. The iPhone cameras have come a ',
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'long'
	                        ),
	                        ' way since that picture was taken - but I still love it.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'yearBreak' },
	                        '2010'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/F65J/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://scontent-dft4-2.cdninstagram.com/t51.2885-15/e15/10727595_814361988657359_189288893_n.jpg', alt: 'Colors of Fall', className: 'img-rounded full' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/Pe57/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://scontent-dft4-2.cdninstagram.com/t51.2885-15/e15/11117146_1416797205304597_1392028079_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/QaOH/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://scontent-dft4-2.cdninstagram.com/t51.2885-15/e15/11143045_1595407514009301_814828095_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'yearBreak' },
	                        '2011'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/OeBd4/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://scontent-dft4-2.cdninstagram.com/t51.2885-15/e15/11191597_1000827033283957_11400648_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/RdySh/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://scontent-dft4-2.cdninstagram.com/t51.2885-15/e15/11176124_1380718895559927_611522467_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/RdzLz/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://scontent-dft4-2.cdninstagram.com/t51.2885-15/e15/11191360_364932673701797_403118138_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/Rdyl-/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://scontent-dft4-2.cdninstagram.com/t51.2885-15/e15/11191583_1588595428087761_142870221_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'yearBreak' },
	                        '2012'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/QNzDyAPTey/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://scontent-dft4-2.cdninstagram.com/t51.2885-15/e15/11193142_612144052255734_1611706927_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/R7-d3-PTWs/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://scontent-dft4-2.cdninstagram.com/t51.2885-15/e15/11235938_1589491471331623_365020928_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'yearBreak' },
	                        '2013'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/gQk8zcPTVJ/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://igcdn-photos-h-a.akamaihd.net/hphotos-ak-xfp1/t51.2885-15/1388833_280342388757551_564069757_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/gwsnodvTSW/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://igcdn-photos-c-a.akamaihd.net/hphotos-ak-xaf1/t51.2885-15/1389792_1411880942381098_1227477084_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/g02MPXPTcQ/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://igcdn-photos-c-a.akamaihd.net/hphotos-ak-xap1/t51.2885-15/1168536_620853047982266_1041316852_n.jpg', alt: 'Fall Tornado', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/gQlEEuvTVU/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://igcdn-photos-g-a.akamaihd.net/hphotos-ak-xap1/t51.2885-15/1389625_200061656843934_90600188_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'yearBreak' },
	                        '2014'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/t5LlJ5PTTb/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://igcdn-photos-g-a.akamaihd.net/hphotos-ak-xaf1/t51.2885-15/10723704_1477959559133958_83782037_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/teJ4p-PTUo/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://igcdn-photos-b-a.akamaihd.net/hphotos-ak-xfp1/t51.2885-15/1173171_661774463930233_1143468844_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/uT-5CiPTXZ/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://igcdn-photos-d-a.akamaihd.net/hphotos-ak-xpa1/t51.2885-15/10693514_567330923372067_1118264708_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/uUAdY6PTal/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://igcdn-photos-b-a.akamaihd.net/hphotos-ak-xpf1/t51.2885-15/10731515_1469658649982753_1031282060_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/uT_RFFvTYB/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://igcdn-photos-g-a.akamaihd.net/hphotos-ak-xap1/t51.2885-15/10731751_588996577892846_2129389418_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/uT_qrKvTYv/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://igcdn-photos-h-a.akamaihd.net/hphotos-ak-xap1/t51.2885-15/10731957_1482546458679151_1449446620_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/p/tpzngrPTVe/', target: '_blank' },
	                            _react2.default.createElement('img', { src: 'https://igcdn-photos-h-a.akamaihd.net/hphotos-ak-xap1/t51.2885-15/10683964_868282609850703_1472498638_n.jpg', alt: 'Colors of Fall', className: 'img-rounded half' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-4 level-two instagram-feed' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Recent Photos'
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.instagram.com/pkimbrel/', target: '_blank' },
	                    '@pkimbrel'
	                ),
	                _react2.default.createElement('iframe', { src: 'https://snapwidget.com/embed/454271', className: 'snapwidget-widget', allowTransparency: 'true', frameBorder: '0', scrolling: 'no', style: { border: 'none', overflow: 'hidden', height: '4000px', width: '100%' } })
	            )
	        )
	    );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-photos-index-js-bf83f8947b82a5f6912b.js